import React, { useState } from "react";

import PhoneField from "../phoneField";
import { FIELD_FONT } from "./kitUi";

/** Who really buys when the sale goes to the campus' "Venta a Terceros" record (Esteban, 2026-10-29). */
export interface TerceroBuyer {
	name: string;
	phone: string;
	heardFrom: string;
}

export const emptyBuyer = (): TerceroBuyer => ({ name: "", phone: "", heardFrom: "" });

/** Same rule as the backend (SalesService::thirdPartyBuyer): first and last name, phone with country code, where they heard of us. */
export const buyerValid = (buyer: TerceroBuyer): boolean => {
	const name = buyer.name.trim().replace(/\s+/g, " ");
	return name.length >= 5 && name.includes(" ") && buyer.phone.replace(/\D/g, "").length >= 10 && buyer.heardFrom.trim().length >= 3;
};

const HEARD_FROM = ["Instagram", "Facebook", "TikTok", "Google", "Recomendación de un Alumno", "Recomendación de Alguien Más", "Pasaba por el Plantel", "Otro"];
/** Campus → país de su lada (ids de país que entiende PhoneField): MX 1, HN 2, SV 60. */
const campusCountry = (campusId: number): number => campusId === 1 || campusId === 2 ? 1 : campusId === 7 ? 60 : 2;

export interface TerceroCompradorProps {
	campusId: number;
	value: TerceroBuyer;
	onChange: (buyer: TerceroBuyer) => void;
	disabled?: boolean;
}

/**
 * Venta a Terceros: quien compra no es alumno. Se pide quién es y dónde escuchó de nuestros productos; la venta cae en
 * Auditoría (Ventas a Terceros) y el comprobante de entrega le llega a ese teléfono.
 */
const TerceroComprador: React.FC<TerceroCompradorProps> = ({ campusId, value, onChange, disabled }) => {
	const listed = HEARD_FROM.includes(value.heardFrom) && value.heardFrom !== "Otro";
	const [other, setOther] = useState<boolean>(value.heardFrom !== "" && !listed);
	const caption: React.CSSProperties = { display: "block", fontSize: "12px", fontWeight: 600, color: "var(--wa-apagado)", marginTop: "8px", marginBottom: "3px" };
	return <div style={{ border: "1px solid var(--wa-oro)", background: "var(--wa-oro-suave)", borderRadius: "8px", padding: "10px 12px", marginTop: "10px" }}>
		<div style={{ fontWeight: 700, fontSize: "14px", color: "var(--wa-tinta)" }}>Venta a Terceros</div>
		<div style={{ fontSize: "12px", color: "var(--wa-apagado)" }}>Quien compra no es alumno. Esta venta pasa a Auditoría.</div>
		<span style={caption}>Nombre y Apellido de Quien Compra</span>
		<input type="text" className="form-control" style={{ fontSize: FIELD_FONT, backgroundColor: "var(--wa-superficie)" }} value={value.name} disabled={disabled} maxLength={150}
			onChange={(event) => onChange({ ...value, name: event.target.value })} />
		<span style={caption}>Teléfono</span>
		<div style={{ backgroundColor: "var(--wa-superficie)", borderRadius: "6px" }}><PhoneField id="terceroTelefono" name="terceroTelefono" value={value.phone} campusCountryId={campusCountry(campusId)} disabled={disabled}
			onChange={(phone) => onChange({ ...value, phone })} /></div>
		<span style={caption}>¿Dónde Escuchó de Nuestros Productos?</span>
		<select className="form-select" style={{ fontSize: FIELD_FONT, backgroundColor: "var(--wa-superficie)" }} disabled={disabled} value={other ? "Otro" : value.heardFrom}
			onChange={(event) => {
				const picked = event.target.value;
				setOther(picked === "Otro");
				onChange({ ...value, heardFrom: picked === "Otro" ? "" : picked });
			}}>
			<option value="">Elegir…</option>
			{HEARD_FROM.map((option) => <option key={option} value={option}>{option}</option>)}
		</select>
		{other ? <input type="text" className="form-control" style={{ fontSize: FIELD_FONT, marginTop: "6px", backgroundColor: "var(--wa-superficie)" }} value={value.heardFrom} disabled={disabled} maxLength={150}
			placeholder="¿Dónde?" onChange={(event) => onChange({ ...value, heardFrom: event.target.value })} /> : null}
	</div>;
};

export default TerceroComprador;
